module.exports = __webpack_public_path__ + "img/budget-remaining.42c2b539.svg";